// Import model
import { DataviewEstimateResponse } from '../models/DataviewEstimateResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { Estimate } from '../models/Estimate';
import { FilterEstimateRequest } from '../models/FilterEstimateRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { EstimateSerializer } from './EstimateSerializer';
import { FilterEstimateRequestSerializer } from './FilterEstimateRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewEstimateResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewEstimateResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewEstimateResponse instance
   */
  static deserialize(json: string): DataviewEstimateResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewEstimateResponse instance
   */
  static fromObject(obj: any): DataviewEstimateResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewEstimateResponse');
    }


    const instance: DataviewEstimateResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        EstimateSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterEstimateRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewEstimateResponse instances
   */
  static deserializeArray(json: string): DataviewEstimateResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewEstimateResponse instance to a JSON string
   */
  static serialize(instance: DataviewEstimateResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewEstimateResponse instance to a plain object
   */
  static toObject(instance: DataviewEstimateResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        EstimateSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterEstimateRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewEstimateResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewEstimateResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
